import { useInjection } from '@cp/shared/di';
import { useCallback } from 'react';
import { ClientSelection } from 'src/entities/client';
import { QUIZ_FEATURE } from '../di';
import { useAuth } from './useAuth';
import { AuthFeature } from './types';

/**
 * Запускает процесс авторизации прежде запустив опрос пользователя
 * @param questions
 */
export const useAuthWithQuiz = (questions?: Array<keyof ClientSelection>): AuthFeature => {
  const auth = useAuth();
  const quiz = useInjection(QUIZ_FEATURE);
  return useCallback(() => quiz(questions || []).then((cs) => auth(cs.unwrap())), [auth, quiz, questions]);
};
